import { tw } from "~/utils";

const PlayButton = ({
  className,
  ...props
}: Omit<React.HTMLAttributes<HTMLButtonElement>, "children">) => (
  <button
    {...props}
    className={tw(
      "z-0 flex size-[70px] items-center justify-center",
      className
    )}
  >
    <span className="absolute left-0 top-0 z-[-1] block size-full scale-100 animate-pulseOut rounded-full bg-purple opacity-100" />
    <span className="absolute left-0 top-0 z-[-1] block size-full scale-100 animate-[pulseOut_1.3s_ease_infinite_1s] rounded-full bg-purple opacity-100" />
    <span className="absolute left-0 top-0 z-0 block size-full rounded-full bg-gradient-to-r from-charcoal to-purple" />
    <svg
      width="21"
      height="24"
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="z-[1] ml-[5px]"
    >
      <path
        d="M20.4729 12.7088L1.66194 23.5717C1.53857 23.6447 1.39866 23.6834 1.25607 23.6842C1.11348 23.685 0.973169 23.6477 0.84906 23.576C0.724951 23.5044 0.621351 23.4009 0.54854 23.2758C0.475729 23.1507 0.436238 23.0084 0.433978 22.8629V1.13707C0.436238 0.991604 0.475729 0.849269 0.54854 0.724182C0.621351 0.599095 0.724951 0.495601 0.84906 0.423967C0.973169 0.352333 1.11348 0.315047 1.25607 0.315807C1.39866 0.316568 1.53857 0.355348 1.66194 0.428302L20.4729 11.2912C20.5967 11.3615 20.6999 11.4643 20.7717 11.5889C20.8435 11.7135 20.8813 11.8555 20.8813 12C20.8813 12.1446 20.8435 12.2865 20.7717 12.4111C20.6999 12.5357 20.5967 12.6385 20.4729 12.7088Z"
        fill="white"
      />
    </svg>
  </button>
);

export default PlayButton;
